export default {"src":"/_next/static/media/person.cad8f99a.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};